import { format, isFuture } from 'date-fns';
import React from 'react';
import { RailsItem } from '~/typings/services/rails/item';

interface Props {
  item: RailsItem;
}

const AuctionEndText: React.FC<Props> = ({ item }) => {
  if (
    !item.auction_ended_at ||
    // Auction not started yet
    (item.auction_started_at && isFuture(new Date(item.auction_started_at)))
  ) {
    return null;
  }

  return (
    <div className="my-3 text-sm italic">
      The highest bid at{' '}
      {format(new Date(item.auction_ended_at), "h:mmaaa 'on' MMMM do")} will win
      the auction.
    </div>
  );
};

export default AuctionEndText;
